export const PATH_HOME = "/";
export const PATH_CARS = PATH_HOME + "cars/";
export const PATH_PREMIUM_OFFERS_SHOP = `${PATH_HOME}premium-offers/`;
export const PATH_PREMIUM_STAYS_VR = `${PATH_HOME}premium-stays/vacation-rentals/`;

export const PATH_HOME_TERMS = `${PATH_HOME}terms/`;
export const PATH_TERMS_COMPLIMENTARY_NIGHT = `${PATH_HOME_TERMS}complimentary-night/`;
export const PATH_TERMS_LUXURY_OFFER = `${PATH_HOME_TERMS}luxury-offer/`;
export const PATH_TERMS_LUX_Q2_VR_OFFER = `${PATH_HOME_TERMS}luxury-q2-vr-offer/`;

export const API_V0_VERSION_PREFIX: string = "/api/v0";

// Wishlist related paths
export const PATH_STAYS = `${PATH_HOME}stays/`;
export const PATH_FAVORITES = `${PATH_STAYS}favorites/`;
export const WISHLISTS_API_PREFIX: string = `${API_V0_VERSION_PREFIX}/travel/wishlists/`;

// Experiences related paths
export const PATH_ACTIVITIES_AVAILABILITY = `${PATH_HOME}activities/availability/`;
export const PATH_ACTIVITIES_SHOP = `${PATH_HOME}activities/shop/`;

// Spreedly related paths
export const PATH_PAYMENTS = `${API_V0_VERSION_PREFIX}/payments/`;

export const PATH_USER = `${API_V0_VERSION_PREFIX}/user/`;

export const PATH_EXPENSE_CONTEXT = `${API_V0_VERSION_PREFIX}/business/accounts/expense-context`;

export const PATH_ENGAGEMENT_EVENT = `${API_V0_VERSION_PREFIX}/engagement/event`;

export const ADMIN_API_V0_PREFIX: string = "/admin/api/v0";
export const PATH_ADMIN_BUSINESS_METADATA_GET = `${ADMIN_API_V0_PREFIX}/businesses/metadata/get`;
export const PATH_ADMIN_BUSINESS_METADATA_PUT = `${ADMIN_API_V0_PREFIX}/businesses/metadata/put`;
